export default __webpack_public_path__ + "images/544083665707b406ac4ec682c945c971-arts.png";